import React from 'react';
import PropTypes from 'prop-types';
import {RadioGroup as MRadioGroup, Radio as MRadio, FormControlLabel, FormControl, FormLabel, FormHelperText} from '@mui/material';

const RadioGroup = (props) => {
  return (
    <FormControl component="fieldset"
      fullWidth={props.fullWidth}
    >
      <FormLabel component="legend">{props.label}</FormLabel>
      <MRadioGroup
        aria-label={props.label}
        row={props.row}
        onChange={(e) => props.onChange(e.target.value)}
        value={props.value}
      >
        {props.children}
      </MRadioGroup>
      <FormHelperText>{props.helperText}</FormHelperText>
    </FormControl>
  );
};

RadioGroup.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  children: PropTypes.node.isRequired,
  row: PropTypes.bool,
  value: PropTypes.any,
  fullWidth: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

const Radio = (props) => {
  return (
    <FormControlLabel
      value={props.value}
      disabled={props.disabled}
      control={<MRadio />}
      label={props.label}
      labelPlacement="end"
    />
  );
};

Radio.propTypes = {
  value: PropTypes.any,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export {
  RadioGroup,
  Radio,
};
